import { useEffect, useRef } from 'react'
import { captureAdClick, getClickSentStatus } from 'src/utils/adbiAttribution'
import { adbiIdentify } from 'src/utils/adbiTracker'

/** Captures gclid/gbraid/wbraid/fbclid on first mount. Safe under StrictMode. */
export function useAdbiClickCapture(): void {
  useEffect(() => {
    void captureAdClick()
  }, [])
}

/**
 * Sends $identify whenever a user ID becomes available (or changes).
 * Binds anonymous_id → user_id in adbi for attribution resolution.
 */
export function useAdbiIdentify(userId: string | undefined): void {
  const lastIdentifiedId = useRef<string | null>(null)

  useEffect(() => {
    if (!userId || lastIdentifiedId.current === userId) return
    // Only identify when an ad click was captured this session — no organic users
    if (getClickSentStatus() !== 'success') return
    lastIdentifiedId.current = userId
    adbiIdentify(userId)
  }, [userId])
}
